import { Button, Container, Heading, Text, VStack } from "@chakra-ui/react";
import { motion, useAnimation } from "framer-motion";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import fitnessGif from "../fitness_image.jpg";
import { FaDumbbell } from "react-icons/fa";

function FirstPage() {
  const controls = useAnimation();
  const navigate = useNavigate();

  useEffect(() => {
    controls.start({
      opacity: 1,
      x: 0,
      transition: { duration: 0.6 },
    });
  }, [controls]);

  const handleLogin = () => {
    navigate("/dashboard");
  };

  return (
    <Container
      maxW="100vw"
      h="100vh"
      p={0}
      position="relative"
      bg="#f3b97f"
      overflow="hidden"
    >
      <motion.img
        src={fitnessGif}
        alt="Fitness Image"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 0
        }}
      />

      <VStack
        spacing={4}
        initial={{ opacity: 0, x: -100 }}
        animate={controls}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        zIndex={1}
        textAlign="center"
        px={4}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 1 }}
        >
          <Heading as="h1" size="2xl" color="white">
            Bugarin Tracker
          </Heading>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 1 }}
        >
          <Text fontSize="xl" color="white">
            Track your fitness goals, stay motivated, and achieve results.
          </Text>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
          whileHover={{ scale: 1.1, y: -10 }}
          whileTap={{ scale: 0.9 }}
        >
          <Button
            colorScheme="red"
            size="lg"
            onClick={handleLogin}
          >
            <FaDumbbell size={20} style={{ marginRight: "8px" }} />
            Login with Bugarin
          </Button>
        </motion.div>

<motion.div
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{ delay: 1, duration: 1 }} // delay lebih besar biar muncul terakhir
  whileHover={{ scale: 1.1, y: -10 }}
  whileTap={{ scale: 0.9 }}
>
  <Button
    as="a" // ubah jadi tag <a>
    href="https://tcnsehat.top/bugarintracker/index.html" // ganti dengan link tujuan kamu
    target="_blank" // buka di tab baru. Hapus kalau mau buka di tab yang sama
    rel="noopener noreferrer"
    colorScheme="blue"
    size="lg"
    variant="outline"
    borderColor="white"
    color="white"
    _hover={{ bg: "white", color: "black" }}
  >
    Home
  </Button>
</motion.div>


      </VStack>
    </Container>
  );
}

export default FirstPage;